<div class="full-screen" *ngIf="type">
  <app-typeform-form [type]="type" [hiddenFields]="hiddenFields"></app-typeform-form>
</div>
